export const provincesMap = [
  { name: 'An Giang', id: 'VN-44', name_eng: 'An Giang' },
  { name: 'Bà Rịa–Vũng Tàu', id: 'VN-43', name_eng: 'Ba Ria-Vung Tau' },
  { name: 'Bắc Giang', id: 'VN-54', name_eng: 'Bac Giang' },
  { name: 'Bắc Kạn', id: 'VN-53', name_eng: 'Bac Kan' },
  { name: 'Bạc Liêu', id: 'VN-55', name_eng: 'Bac Lieu' },
  { name: 'Bắc Ninh', id: 'VN-56', name_eng: 'Bac Ninh' },
  { name: 'Bến Tre', id: 'VN-50', name_eng: 'Ben Tre' },
  { name: 'Bình Định', id: 'VN-31', name_eng: 'Binh Dinh' },
  { name: 'Bình Dương', id: 'VN-57', name_eng: 'Binh Duong' },
  { name: 'Bình Phước', id: 'VN-58', name_eng: 'Binh Phuoc' },
  { name: 'Bình Thuận', id: 'VN-40', name_eng: 'Binh Thuan' },
  { name: 'Cà Mau', id: 'VN-59', name_eng: 'Ca Mau' },
  { name: 'Cần Thơ', id: 'VN-CT', name_eng: 'Can Tho' },
  { name: 'Cao Bằng', id: 'VN-04', name_eng: 'Cao Bang' },
  { name: 'Đà Nẵng', id: 'VN-DN', name_eng: 'Da Nang' },
  { name: 'Đắk Lắk', id: 'VN-33', name_eng: 'Dak Lak|Dac Lac' },
  { name: 'Đắk Nông', id: 'VN-72', name_eng: 'Dac Nong' },
  { name: 'Điện Biên', id: 'VN-71', name_eng: 'Dien Bien' },
  { name: 'Đồng Nai', id: 'VN-39', name_eng: 'Dong Nai' },
  { name: 'Đồng Tháp', id: 'VN-45', name_eng: 'Dong Thap' },
  { name: 'Gia Lai', id: 'VN-30', name_eng: 'Gia Lai' },
  { name: 'Hà Giang', id: 'VN-03', name_eng: 'Ha Giang' },
  { name: 'Hà Nam', id: 'VN-63', name_eng: 'Ha Nam' },
  { name: 'Hà Nội', id: 'VN-HN', name_eng: 'Hanoi' },
  { name: 'Hà Tĩnh', id: 'VN-23', name_eng: 'Ha Tinh' },
  { name: 'Hải Dương', id: 'VN-61', name_eng: 'Hai Duong' },
  { name: 'Hải Phòng', id: 'VN-HP', name_eng: 'Haiphong' },
  { name: 'Hậu Giang', id: 'VN-73', name_eng: 'Hau Giang' },
  { name: 'Hòa Bình', id: 'VN-14', name_eng: 'Hoa Binh' },
  { name: 'Hưng Yên', id: 'VN-66', name_eng: 'Hung Yen' },
  { name: 'Khánh Hòa', id: 'VN-34', name_eng: 'Khanh Hoa' },
  { name: 'Kiên Giang', id: 'VN-47', name_eng: 'Kien Giang' },
  { name: 'Kon Tum', id: 'VN-28', name_eng: 'Kon Tum' },
  { name: 'Lai Châu', id: 'VN-01', name_eng: 'Lai Chau' },
  { name: 'Lâm Đồng', id: 'VN-35', name_eng: 'Lam Dong' },
  { name: 'Lạng Sơn', id: 'VN-09', name_eng: 'Lang Son' },
  { name: 'Lào Cai', id: 'VN-02', name_eng: 'Lao Cai' },
  { name: 'Long An', id: 'VN-41', name_eng: 'Long An' },
  { name: 'Nam Định', id: 'VN-67', name_eng: 'Nam Dinh' },
  { name: 'Nghệ An', id: 'VN-22', name_eng: 'Nghe An' },
  { name: 'Ninh Bình', id: 'VN-18', name_eng: 'Ninh Binh' },
  { name: 'Ninh Thuận', id: 'VN-36', name_eng: 'Ninh Thuan' },
  { name: 'Phú Thọ', id: 'VN-68', name_eng: 'Phu Tho' },
  { name: 'Phú Yên', id: 'VN-32', name_eng: 'Phu Yen' },
  { name: 'Quảng Bình', id: 'VN-24', name_eng: 'Quang Binh' },
  { name: 'Quảng Nam', id: 'VN-27', name_eng: 'Quang Nam' },
  { name: 'Quảng Ngãi', id: 'VN-29', name_eng: 'Quang Ngai' },
  { name: 'Quảng Ninh', id: 'VN-13', name_eng: 'Quang Ninh' },
  { name: 'Quảng Trị', id: 'VN-25', name_eng: 'Quang Tri' },
  { name: 'Sóc Trăng', id: 'VN-52', name_eng: 'Soc Trang' },
  { name: 'Sơn La', id: 'VN-05', name_eng: 'Son La' },
  { name: 'Tây Ninh', id: 'VN-37', name_eng: 'Tay Ninh' },
  { name: 'Thái Bình', id: 'VN-20', name_eng: 'Thai Binh' },
  { name: 'Thái Nguyên', id: 'VN-69', name_eng: 'Thai Nguyen' },
  { name: 'Thanh Hóa', id: 'VN-21', name_eng: 'Thanh Hoa' },
  { name: 'Thừa Thiên-Huế', id: 'VN-26', name_eng: 'Thua Thien - Hue' },
  { name: 'Tiền Giang', id: 'VN-46', name_eng: 'Tien Giang' },
  { name: 'Hồ Chí Minh', id: 'VN-SG', name_eng: 'Ho Chi Minh' },
  { name: 'Trà Vinh', id: 'VN-51', name_eng: 'Tra Vinh' },
  { name: 'Tuyên Quang', id: 'VN-07', name_eng: 'Tuyen Quang' },
  { name: 'Vĩnh Long', id: 'VN-49', name_eng: 'Vinh Long' },
  { name: 'Vĩnh Phúc', id: 'VN-70', name_eng: 'Vinh Phuc' },
  { name: 'Yên Bái', id: 'VN-06', name_eng: 'Yen Bai' }
];



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/vietnam-map/vietnam-province-map.ts